import {Component, ViewChild} from '@angular/core';
import {DefaultUrlSerializer, NavigationEnd, NavigationStart, Router, UrlTree} from "@angular/router";
import {Select, Store} from "@ngxs/store";
import {interval} from "rxjs";
import {LoadDatabase, ShowTutorial} from "./core/state/core.actions";
import {HistoryService} from "./history/services/history.service";
import {AuthService} from './core/services/auth.service';
import {Database, TutorialSlide} from "./core/models";
import { DatePipe } from '@angular/common';
import {SideService} from "./core/services/side.service";
import {MatDialog} from "@angular/material/dialog";
import {ConfirmLogoutDialogComponent} from "./auth/confirm-logout-dialog/confirm-logout-dialog.component";
import {ConfirmDialogComponent} from "./shared/confirm-dialog/confirm-dialog.component";
import {Subject} from "rxjs/index";
import {CoreService} from "./core/services/core.service";
import {TutorialComponent} from "./tutorial/tutorial.component";
import {UpdateDashboard} from "./dashboard/state/dashboard.actions";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  readonly loggedIn$ = this.authService.loggedIn$;
  readonly user$ = this.authService.user$;
  readonly login$ = this.authService.login$;
  readonly logout$ = this.authService.logout$;

  @ViewChild('sideComponentRef') sideComponentRef;

  @Select((s) => s.core.database) database$;
  user: string = "";
  license: string = "";
  show_tutorial: boolean = false;
  database_ver: string = "";
  system_ver: string = "";
  every_minute = interval(1000 * 60);
  now = new Date();
  logoActive = false;
  sideActive = false;
  pausedRoute = {};

  destroyed$ = new Subject();

  constructor(private authService: AuthService,
              private coreService: CoreService,
              private historyService: HistoryService,
              private store: Store,
              public router: Router,
              private sideService: SideService,
              private dialog: MatDialog) {
  }

  ngOnInit(): void {
    this.database$.subscribe((v: Database) => {
      this.database_ver = v.date;
      this.system_ver = v.system_ver;
    });

    this.user$.subscribe((v: any) => {
      if(v) {
        this.user = v.name;
        this.license = v.license;
        this.show_tutorial = v.show_tutorial;
        if(v.show_tutorial) {
          // this.showTutorial();
          this.store.dispatch(
            new ShowTutorial(true)
          );
        }
      }
    });

    this.store.dispatch(
      new LoadDatabase()
    );
    this.store.select((s) => s.core.showTutorial).subscribe(
      (showTutorial) => {
        if(showTutorial) {
          this.showTutorial();
        }
    });

    this.login$.subscribe(v => {
      this.historyService.addAction({'text': 'вошёл в систему', 'model': 'auth', 'operation': 'login'})
    });

    this.logout$.subscribe(v => {
      this.historyService.addAction({'text': 'вышел из системы', 'model': 'auth', 'operation': 'logout'})
    });

    this.every_minute.subscribe(() => this.now = new Date());

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.logoActive = event.url != '/';
      }
    });

    this.sideService.activeComponent$.subscribe(v => {
      this.logoActive = v == null;
      this.sideActive = v != null
    });

    const sourcePing = interval(15 * 60 * 1000);
    sourcePing.subscribe(val => this.authService.ping().subscribe(v => {}));

    window.addEventListener('popstate', (e: PopStateEvent) => {
      if(this.sideActive) {
        e.preventDefault();
        e.stopPropagation();
        const str = this.router.isActive('dashboard', false) ? 'Сохранить виджет?' : 'Сохранить выборку?';

        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
          data: {
            text: str,
            confirmText: 'Да',
            cancelText: 'Нет'
          }
        });

        dialogRef.afterClosed().subscribe(
      (value) => {
          if(this.sideComponentRef.componentRef.instance.save && this.sideComponentRef.componentRef.instance.close) {
            if (value) {
              this.sideComponentRef.componentRef.instance.save(true);
            } else {
              this.sideComponentRef.componentRef.instance.close();
            }
          } else {
            this.sideService.close();
          }
        });
      }
    });
  }

  logout() {
    const dialogRef = this.dialog.open(ConfirmLogoutDialogComponent);
    dialogRef.afterClosed().subscribe(
      (value) => {
        if (value) {
          this.authService.logout();
        }
      }
    );
  }

  home(e) {
    e.preventDefault();
    if(this.logoActive) {
      this.router.navigate([''])
    }
  }

  reports() {
    this.router.navigate(['reports'])
  }

  selections() {
    this.router.navigate(['selections'])
  }

  history() {
    this.router.navigate(['history'])
  }

  university() {
    this.router.navigate(['university'])
  }

  help() {
    this.router.navigate(['help'])
  }

  dashboard() {
    this.router.navigate(['dashboard'])
  }

  getSystemInfoTooltip() {
    let pipe = new DatePipe('ru-RU');
    let database_ver = '';
    if(this.database_ver) {
      database_ver = pipe.transform(this.database_ver, 'dd.MM.yyyy');
    }
    const now = pipe.transform(this.now, 'dd.MM.yyyy');
    return (this.user ? 'Пользователь: ' + this.user + '\n' : '') +
           (this.license ? 'Лицензиат: ' + this.license + '\n': '') +
           (database_ver ? 'База данных: ' + database_ver + '\n': '') +
           (this.system_ver ? 'Версия системы: ' + this.system_ver + '\n': '') +
           ('Дата: ' + now)
  }

  showTutorial() {
      this.coreService.fetchTutorial().subscribe(
      (slides: TutorialSlide[]) => {
        if(slides && slides.length > 0) {
        const config = {
          width: '150vh',
          autoFocus: false,
          data: {
            slides: slides,
            showNextTime: this.show_tutorial
          }
        };
        const dialogRef = this.dialog.open(TutorialComponent, config);
        dialogRef.afterClosed().subscribe(
      (value) => {

          this.show_tutorial = value;
          this.store.dispatch(
            new ShowTutorial(false)
          );
      }
    );
      }
    });
  }
}
